import { createAction, props } from '@ngrx/store';
import { CombinedContactPoint } from '../../models/combined-contact-point.model';

export const getForParty = createAction(
    '[Contact Points] Get For Party',
    props<{
        partyId: string;
    }>()
);

export const getForPartySuccess = createAction(
    '[Contact Points] Get For Party Success',
    props<{
        partyId: string;
        contactPoints: CombinedContactPoint[];
    }>()
);

export const getForPartyFailure = createAction(
    '[Contact Points] Get For Party Failure',
    props<{
        partyId: string;
        error: Error;
    }>()
);
